import { FaChartLine, FaDollarSign } from "react-icons/fa";
import { Card } from "../common/Card";
import { ErrorRetry } from "../../common/ErrorRetry";
import {
  formatHotelMoney,
  formatHotelPercentage,
} from "./hotelReportUtils";

export function HotelRevenueStreamsSection({ state, revenueStreams }) {
  return (
    <Card className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
      <span className="mb-6 text-[#1A1A1A] text-lg">Revenue Streams</span>
      {state.loading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 animate-pulse">
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className="h-40 rounded-xl bg-gray-100" />
          ))}
        </div>
      ) : state.error ? (
        <div className="h-[220px] flex items-center justify-center">
          <ErrorRetry message={state.message} onRetry={state.onRetry} />
        </div>
      ) : revenueStreams.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {revenueStreams.map((stream, index) => {
            const isUp =
              stream.status === "up" || stream.status?.startsWith("up");

            return (
              <div
                key={`${stream.label}-${index}`}
                className="relative overflow-hidden rounded-xl border border-gray-100 bg-gradient-to-br from-white to-gray-50 p-6 shadow-sm hover:shadow-md transition-all duration-300"
              >
                <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-[#1E61DC]/10 to-transparent rounded-bl-full" />

                <div className="relative">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#1E61DC] to-[#60A5FA] flex items-center justify-center mb-4">
                    <FaDollarSign className="w-6 h-6 text-white" />
                  </div>

                  <div className="text-[#6B7280] mb-2">{stream.label}</div>

                  <div className="text-2xl font-semibold text-[#1A1A1A] mb-1">
                    {formatHotelMoney(stream.amount)}
                  </div>

                  <div className="flex items-center justify-between mt-3">
                    <span className="text-sm text-[#6B7280]">Revenue share</span>
                    <div className="flex items-center gap-1 px-2 py-1 rounded-full bg-[#1E61DC]/10">
                      <span className="text-sm font-medium text-[#1E61DC]">
                        {formatHotelPercentage(stream.sharePercentage)}
                      </span>
                    </div>
                  </div>

                  <div
                    className={`flex items-center gap-1 mt-2 ${
                      isUp ? "text-green-600" : "text-red-600"
                    }`}
                  >
                    <FaChartLine className="w-4 h-4" />
                    <span className="text-sm">
                      {isUp ? "+" : ""}
                      {formatHotelPercentage(stream.changePercentage)}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="h-[220px] flex items-center justify-center text-gray-500">
          No revenue streams available
        </div>
      )}
    </Card>
  );
}
